import React, { useState, useEffect, useContext } from "react";
import {
  Table,
  Card,
  Typography,
  Tag,
  Row,
  Col,
  Statistic,
  DatePicker,
  Select,
  Button,
  Tooltip,
  Space,
  Empty,
  Badge,
  Modal,
  Upload,
  Alert,
  Divider,
  Progress,
  message,
} from "antd";
import {
  ArrowUpOutlined,
  ArrowDownOutlined,
  BankOutlined,
  MobileOutlined,
  MoneyCollectOutlined,
  FileExcelOutlined,
  SwapOutlined,
  DollarCircleOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import axios from "axios";
import moment from "moment";
import Papa from "papaparse";
import { AppContext } from "../context/AppContext";

const { Title, Text } = Typography;
const { RangePicker } = DatePicker;
const { Option } = Select;

// Zambian colors
const ZAMBIAN_COLORS = {
  green: "#078930",
  red: "#EF3340",
  black: "#000000",
  orange: "#FFB81C",
};

const TransactionsPage = () => {
  const { company, accounts } = useContext(AppContext);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    dateRange: [moment().subtract(7, "days"), moment()],
    transactionType: "all",
    status: "all",
    account: "all",
  });
  const token = localStorage.getItem("token");

  // Bulk upload states
  const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);
  const [bulkUploadFile, setBulkUploadFile] = useState(null);
  const [bulkUploadLoading, setBulkUploadLoading] = useState(false);
  const [bulkUploadProgress, setBulkUploadProgress] = useState(0);

  const transactionTypes = [
    { label: "Loan Disbursement", value: "Loan Disbursement" },
    { label: "Loan Repayment", value: "Loan Repayment" },
    { label: "Account Transfer", value: "Account Transfer" },
    { label: "Transfer Fees", value: "Transfer Fees" },
    { label: "Operational Cost", value: "Operational Cost" },
    { label: "Float Addition", value: "Float Addition" },
    { label: "Admin Fees", value: "Admin Fees" },
    { label: "Penalty Fee", value: "Penalty Fee" },
    { label: "Interest Payment", value: "Interest Payment" },
  ];

  const paymentMethods = [
    { label: "Mobile Money", value: "mobile_money", icon: <MobileOutlined /> },
    { label: "Bank Transfer", value: "bank_transfer", icon: <BankOutlined /> },
    { label: "Cash", value: "cash", icon: <MoneyCollectOutlined /> },
    {
      label: "Internal Transfer",
      value: "internal_transfer",
      icon: <SwapOutlined />,
    },
  ];

  const statusColors = {
    Completed: "green",
    Pending: "orange",
    Failed: "red",
  };

  const columns = [
    {
      title: "Date",
      dataIndex: "transaction_date",
      render: (date) => moment(date).format("DD MMM YYYY"),
      sorter: (a, b) => moment(b.transaction_date) - moment(a.transaction_date),
    },
    {
      title: "Type",
      dataIndex: "transaction_type",
      render: (type) => (
        <Tag
          color={
            type === "Loan Disbursement" ||
            type === "Transfer Fees" ||
            type === "Operational Cost" ||
            type.includes("Outflow")
              ? "volcano" // Show outflow transactions in red
              : type === "Account Transfer"
              ? "blue"
              : type === "Loan Repayment" ||
                type === "Float Addition" ||
                type === "Admin Fees" ||
                type.includes("Inflow")
              ? "cyan"
              : "default"
          }
        >
          {type}
        </Tag>
      ),
      filters: transactionTypes.map((t) => ({ text: t.label, value: t.value })),
      onFilter: (value, record) => record.transaction_type === value,
    },
    // {
    //   title: "From Account",
    //   dataIndex: "from_account",
    //   render: (fromAccount, record) => {
    //     // Handle cases where from_account is an object or an ID
    //     if (fromAccount && typeof fromAccount === 'object' && fromAccount.name) {
    //       return (
    //         <Space>
    //           <BankOutlined style={{ color: ZAMBIAN_COLORS.green }} />
    //           <span>{fromAccount.name}</span>
    //         </Space>
    //       );
    //     }

    //     // Try to find it in the accounts context if it's an ID
    //     const accountId = typeof fromAccount === 'string' || typeof fromAccount === 'number'
    //       ? fromAccount
    //       : record.from_account_id;

    //     const account = accounts?.find((acc) => acc.id === accountId);

    //     return account ? (
    //       <Space>
    //         <BankOutlined style={{ color: ZAMBIAN_COLORS.green }} />
    //         <span>{account.name}</span>
    //       </Space>
    //     ) : (
    //       "N/A"
    //     );
    //   },
    //   filters:
    //     accounts?.map((account) => ({
    //       text: account.name,
    //       value: account.id,
    //     })) || [],
    //   onFilter: (value, record) => {
    //     if (record.from_account && typeof record.from_account === 'object') {
    //       return record.from_account.id === value;
    //     }
    //     return record.from_account === value || record.from_account_id === value;
    //   },
    // },
    // {
    //   title: "To Account",
    //   dataIndex: "to_account",
    //   render: (toAccount, record) => {
    //     // Check if transaction is a loan disbursement to borrower
    //     if (record.transaction_type === "Loan Disbursement" && !toAccount) {
    //       return (
    //         <Space>
    //           <DollarCircleOutlined style={{ color: ZAMBIAN_COLORS.orange }} />
    //           <span>Borrower</span>
    //         </Space>
    //       );
    //     }

    //     // Handle cases where to_account is an object or an ID
    //     if (toAccount && typeof toAccount === 'object' && toAccount.name) {
    //       return (
    //         <Space>
    //           <BankOutlined style={{ color: ZAMBIAN_COLORS.green }} />
    //           <span>{toAccount.name}</span>
    //         </Space>
    //       );
    //     }

    //     // Try to find it in the accounts context if it's an ID
    //     const accountId = typeof toAccount === 'string' || typeof toAccount === 'number'
    //       ? toAccount
    //       : record.to_account_id;

    //     const account = accounts?.find((acc) => acc.id === accountId);

    //     return account ? (
    //       <Space>
    //         <BankOutlined style={{ color: ZAMBIAN_COLORS.green }} />
    //         <span>{account.name}</span>
    //       </Space>
    //     ) : (
    //       "N/A"
    //     );
    //   },
    //   filters:
    //     accounts?.map((account) => ({
    //       text: account.name,
    //       value: account.id,
    //     })) || [],
    //   onFilter: (value, record) => {
    //     if (record.to_account && typeof record.to_account === 'object') {
    //       return record.to_account.id === value;
    //     }
    //     return record.to_account === value || record.to_account_id === value;
    //   },
    // },
    {
      title: "Borrower",
      dataIndex: "loan",
      render: (loan) => {
        if (!loan || !loan.borrower) return "N/A";
        return (
          <Tooltip title={`NRC: ${loan.borrower.nrc || "N/A"}`}>
            <div>
              <div>{`${loan.borrower.first_name || ""} ${
                loan.borrower.last_name || ""
              }`}</div>
              <Text type="secondary">{`Ref: ${
                loan.borrower.employee_number || "N/A"
              }`}</Text>
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "transaction_status",
      render: (status) => <Tag color={statusColors[status]}>{status}</Tag>,
      filters: [
        { text: "Completed", value: "Completed" },
        { text: "Pending", value: "Pending" },
        { text: "Failed", value: "Failed" },
      ],
      onFilter: (value, record) => record.transaction_status === value,
    },
    {
      title: "Method",
      dataIndex: "payment_method",
      render: (method) => {
        const methodInfo = paymentMethods.find((m) => m.value === method);
        return methodInfo ? (
          <Space>
            {methodInfo.icon}
            <span>{methodInfo.label}</span>
          </Space>
        ) : (
          "N/A"
        );
      },
      filters: paymentMethods.map((m) => ({ text: m.label, value: m.value })),
      onFilter: (value, record) => record.payment_method === value,
    },
    {
      title: "Amount",
      dataIndex: "amount",
      render: (amount, record) => (
        <Text
          strong
          style={{
            // Show outflow transactions as red, inflow as green
            color:
              record.transaction_type === "Loan Disbursement" ||
              record.transaction_type === "Transfer Fees" ||
              record.transaction_type === "Operational Cost"
                ? ZAMBIAN_COLORS.red
                : record.transaction_type === "Admin Fees" ||
                  record.transaction_type === "Float Addition" ||
                  record.transaction_type === "Loan Repayment"
                ? ZAMBIAN_COLORS.green
                : amount > 0
                ? ZAMBIAN_COLORS.green
                : ZAMBIAN_COLORS.red,
          }}
        >
          {amount !== null && amount !== undefined
            ? `ZMW ${Math.abs(amount).toLocaleString()}`
            : "ZMW 0"}
        </Text>
      ),
      sorter: (a, b) => (a.amount || 0) - (b.amount || 0),
    },
    {
      title: "Reference",
      dataIndex: "reference_number",
      render: (ref) => ref || "N/A",
    },
    {
      title: "Notes",
      dataIndex: "notes",
      render: (notes) => notes || "N/A",
      ellipsis: true,
    },
  ];

  const exportToCSV = () => {
    const csvContent = [
      [
        "Date",
        "Type",
        "From Account",
        "To Account",
        "Borrower Name",
        "Employee Number",
        "NRC",
        "Status",
        "Method",
        "Amount (ZMW)",
        "Reference",
        "Notes",
      ],
      ...transactions.map((t) => {
        // Handle different data structures
        let fromAccountName = "N/A";
        let toAccountName = "N/A";

        // From account
        if (t.from_account) {
          if (typeof t.from_account === "object" && t.from_account.name) {
            // Object with name property
            fromAccountName = t.from_account.name;
          } else {
            // ID reference
            const account = accounts?.find((acc) => acc.id === t.from_account);
            if (account) {
              fromAccountName = account.name;
            }
          }
        }

        // To account
        if (t.to_account) {
          if (typeof t.to_account === "object" && t.to_account.name) {
            // Object with name property
            toAccountName = t.to_account.name;
          } else {
            // ID reference
            const account = accounts?.find((acc) => acc.id === t.to_account);
            if (account) {
              toAccountName = account.name;
            }
          }
        } else if (t.transaction_type === "Loan Disbursement") {
          toAccountName = "Borrower";
        }

        return [
          moment(t.transaction_date).format("YYYY-MM-DD"),
          t.transaction_type,
          fromAccountName,
          toAccountName,
          t.loan?.borrower
            ? `${t.loan.borrower.first_name || ""} ${
                t.loan.borrower.last_name || ""
              }`.trim()
            : "N/A",
          t.loan?.borrower?.employee_number || "N/A",
          t.loan?.borrower?.nrc || "N/A",
          t.transaction_status,
          paymentMethods.find((m) => m.value === t.payment_method)?.label ||
            "N/A",
          // Use absolute value for loan disbursements to show as outflow
          t.amount
            ? t.transaction_type === "Loan Disbursement"
              ? Math.abs(t.amount)
              : t.amount
            : 0,
          t.reference_number || "",
          t.notes || "",
        ];
      }),
    ]
      .map((e) => e.join(","))
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `transactions_${moment().format("YYYYMMDD")}.csv`;
    link.click();
  };

  const fetchTransactions = async () => {
    try {
      setLoading(true);

      // Build filter parameters
      const filterParams = {
        company: company.id,
        transaction_date: {
          _between: [
            filters.dateRange[0].startOf('day').toISOString(),
            filters.dateRange[1].endOf('day').toISOString(),
          ],
        },
        ...(filters.transactionType !== "all" && {
          transaction_type: filters.transactionType,
        }),
        ...(filters.status !== "all" && {
          transaction_status: filters.status,
        }),
        ...(filters.account !== "all" && {
          _or: [
            { from_account: filters.account },
            { to_account: filters.account },
          ],
        }),
      };

      // Fetch transactions with all applicable filters
      const response = await axios.get(
        "https://zedlenders.pickmesms.com/items/transactions",
        {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            fields: "*, loan.*, loan.borrower.*, from_account.*, to_account.*",
            filter: filterParams,
            sort: ["-date_created", "-transaction_date"],
          },
        }
      );

      // Log the first transaction for debugging
      if (response.data.data.length > 0) {
        console.log("Sample transaction structure:", response.data.data[0]);
      }

      // Process the transactions to ensure they have the right account information
      const processedTransactions = response.data.data.map((transaction) => {
        // Check if from_account and to_account are relation fields that need to be processed
        if (
          transaction.from_account &&
          typeof transaction.from_account === "object" &&
          transaction.from_account.id
        ) {
          // If from_account is a relation object, make a copy
          const processedTransaction = { ...transaction };
          // Store the ID in a new property for reference
          processedTransaction.from_account_id = transaction.from_account.id;
          return processedTransaction;
        } else {
          // We may need to add fetched accounts by ID from your local accounts array
          return transaction;
        }
      });

      setTransactions(processedTransactions);
    } catch (error) {
      console.error("Error fetching transactions:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (company?.id) {
      fetchTransactions();
    }
  }, [filters, company?.id]);

  // Calculate summary statistics by account
  const getAccountSummaries = () => {
    const accountSummaries = [];

    if (accounts && accounts.length > 0) {
      // Get current balance for each account from accounts collection
      accounts.forEach((account) => {
        accountSummaries.push({
          id: account.id,
          name: account.name,
          balance: account.balance || 0,
          is_default: account.is_default,
        });
      });
    }

    return accountSummaries;
  };

  const accountSummaries = getAccountSummaries();

  // Calculate overall summary numbers
  const getTotalSummary = () => {
    // Use transaction data for period statistics
    const filteredTransactions = transactions || [];

    // Total transactions in current filter period
    const totalTransactions = filteredTransactions.length;

    // Calculate inflows for the period (payments/repayments)
    const totalInflow = filteredTransactions
      .filter(
        (t) => t.amount > 0 && t.transaction_type !== "Loan Disbursement" // Exclude loan disbursements from inflow
      )
      .reduce((sum, t) => sum + (t.amount || 0), 0);

    // Calculate outflows for the period
    // Include both negative transactions AND loan disbursements (even if positive)
    const totalOutflow = filteredTransactions
      .filter(
        (t) =>
          t.amount < 0 || // Negative amount transactions
          t.transaction_type === "Loan Disbursement" // Include ALL loan disbursements
      )
      .reduce((sum, t) => sum + Math.abs(t.amount || 0), 0);

    // Current company balance is sum of all account balances
    const currentBalance = accountSummaries.reduce(
      (sum, account) => sum + (account.balance || 0),
      0
    );

    return { totalTransactions, totalInflow, totalOutflow, currentBalance };
  };

  const summary = getTotalSummary();

  const renderAccountCards = () => {
    return accountSummaries.map((account) => (
      <Col xs={24} sm={12} md={8} lg={6} key={account.id}>
        <Card
          bordered={false}
          style={{
            borderLeft: `3px solid ${
              account.is_default ? ZAMBIAN_COLORS.green : ZAMBIAN_COLORS.black
            }`,
            borderRadius: "4px",
            height: "100%",
          }}
        >
          <Space direction="vertical" style={{ width: "100%" }}>
            <Space>
              <BankOutlined
                style={{
                  color: account.is_default
                    ? ZAMBIAN_COLORS.green
                    : ZAMBIAN_COLORS.black,
                }}
              />
              <Text strong>{account.name}</Text>
              {account.is_default && (
                <Badge color={ZAMBIAN_COLORS.green} text="Default" />
              )}
            </Space>
            <Statistic
              value={account.balance || 0}
              precision={2}
              valueStyle={{ color: ZAMBIAN_COLORS.black }}
              prefix="ZMW"
              formatter={(value) => value.toLocaleString()}
            />
          </Space>
        </Card>
      </Col>
    ));
  };

  return (
    <div style={{ padding: 24 }}>
      <Card bordered={false}>
        <Row
          justify="space-between"
          align="middle"
          style={{ marginBottom: 24 }}
        >
          <Col>
            <Title
              level={3}
              style={{ marginBottom: 0, color: ZAMBIAN_COLORS.green }}
            >
              Transaction History
            </Title>
            <Text type="secondary">
              {company?.name} • Updated {moment().format("DD MMM YYYY")}
            </Text>
          </Col>
          <Col>
            <Button.Group>
              <Button
                icon={<UploadOutlined />}
                onClick={() => setShowBulkUploadModal(true)}
                style={{
                  backgroundColor: ZAMBIAN_COLORS.green,
                  borderColor: ZAMBIAN_COLORS.green,
                  color: "white",
                }}
              >
                Bulk Upload Payments
              </Button>
              <Button
                icon={<FileExcelOutlined />}
                onClick={exportToCSV}
                style={{
                  borderColor: ZAMBIAN_COLORS.green,
                  color: ZAMBIAN_COLORS.green,
                }}
              >
                Export CSV
              </Button>
            </Button.Group>
          </Col>
        </Row>

        {/* Account Balance Cards */}
        <Card
          title={
            <Space>
              <BankOutlined />
              <span>Account Balances</span>
            </Space>
          }
          style={{ marginBottom: 24 }}
          bordered={false}
        >
          {accounts && accounts.length > 0 ? (
            <Row gutter={[16, 16]}>{renderAccountCards()}</Row>
          ) : (
            <Empty description="No accounts found" />
          )}
        </Card>

        {/* Summary Cards */}
        <Row gutter={16} style={{ marginBottom: 24 }}>
          <Col xs={24} sm={12} lg={6}>
            <Card bordered={false}>
              <Statistic
                title="Total Transactions"
                value={summary.totalTransactions}
                valueStyle={{ color: ZAMBIAN_COLORS.black }}
              />
            </Card>
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <Card bordered={false}>
              <Statistic
                title="Total Inflow"
                value={summary.totalInflow}
                prefix={<ArrowDownOutlined />}
                valueStyle={{ color: ZAMBIAN_COLORS.green }}
                suffix="ZMW"
                formatter={(value) => value.toLocaleString()}
              />
            </Card>
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <Card bordered={false}>
              <Statistic
                title="Total Outflow"
                value={summary.totalOutflow}
                prefix={<ArrowUpOutlined />}
                valueStyle={{ color: ZAMBIAN_COLORS.red }}
                suffix="ZMW"
                formatter={(value) => value.toLocaleString()}
              />
            </Card>
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <Card bordered={false}>
              <Statistic
                title="Total Balance"
                value={summary.currentBalance}
                valueStyle={{ color: ZAMBIAN_COLORS.black }}
                suffix="ZMW"
                formatter={(value) => value.toLocaleString()}
              />
            </Card>
          </Col>
        </Row>

        {/* Filters */}
        <Row gutter={16} style={{ marginBottom: 24 }}>
          <Col xs={24} sm={24} md={8} lg={8}>
            <RangePicker
              value={filters.dateRange}
              onChange={(dates) => setFilters({ ...filters, dateRange: dates })}
              style={{ width: "100%" }}
            />
          </Col>
          <Col xs={24} sm={12} md={6} lg={5}>
            <Select
              placeholder="Transaction Type"
              defaultValue="all"
              style={{ width: "100%" }}
              onChange={(value) =>
                setFilters({ ...filters, transactionType: value })
              }
            >
              <Option value="all">All Types</Option>
              {transactionTypes.map((type) => (
                <Option key={type.value} value={type.value}>
                  {type.label}
                </Option>
              ))}
            </Select>
          </Col>
          <Col xs={24} sm={12} md={5} lg={5}>
            <Select
              placeholder="Status"
              defaultValue="all"
              style={{ width: "100%" }}
              onChange={(value) => setFilters({ ...filters, status: value })}
            >
              <Option value="all">All Statuses</Option>
              <Option value="Completed">Completed</Option>
              <Option value="Pending">Pending</Option>
              <Option value="Failed">Failed</Option>
            </Select>
          </Col>
          <Col xs={24} sm={12} md={5} lg={6}>
            <Select
              placeholder="Account"
              defaultValue="all"
              style={{ width: "100%" }}
              onChange={(value) => setFilters({ ...filters, account: value })}
              optionFilterProp="children"
              showSearch
            >
              <Option value="all">All Accounts</Option>
              {accounts?.map((account) => (
                <Option key={account.id} value={account.id}>
                  {account.name}
                </Option>
              ))}
            </Select>
          </Col>
        </Row>

        {/* Transactions Table */}
        <Table
          columns={columns}
          dataSource={transactions}
          rowKey="id"
          loading={loading}
          scroll={{ x: true }}
          pagination={{
            pageSize: 10,
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "50", "100"],
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} of ${total} transactions`,
          }}
        />
      </Card>

      {/* Bulk Payment Upload Modal */}
      <Modal
        title="Bulk Payment Upload"
        open={showBulkUploadModal}
        onCancel={() => {
          setShowBulkUploadModal(false);
          setBulkUploadFile(null);
          setBulkUploadProgress(0);
        }}
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              setShowBulkUploadModal(false);
              setBulkUploadFile(null);
              setBulkUploadProgress(0);
            }}
          >
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            icon={<UploadOutlined />}
            loading={bulkUploadLoading}
            disabled={!bulkUploadFile || bulkUploadLoading}
            onClick={handleBulkPaymentUpload}
            style={{
              backgroundColor: ZAMBIAN_COLORS.green,
              borderColor: ZAMBIAN_COLORS.green,
            }}
          >
            Process Upload
          </Button>,
        ]}
        width={700}
      >
        <Alert
          message="Bulk Payment Upload Instructions"
          description={
            <div>
              <p>Upload a CSV file with the following columns:</p>
              <ul style={{ marginBottom: 0 }}>
                <li><strong>loan_id:</strong> The loan ID (from your loans table)</li>
                <li><strong>payment_amount:</strong> Amount being paid</li>
                <li><strong>payment_date:</strong> Date in format YYYY-MM-DD</li>
                <li><strong>payment_method:</strong> cash, mobile_money, or bank_transfer</li>
                <li><strong>transaction_type:</strong> Usually "Loan Repayment"</li>
                <li><strong>reference_number:</strong> (Optional) Payment reference</li>
              </ul>
            </div>
          }
          type="info"
          showIcon
          style={{ marginBottom: 16 }}
        />

        <Divider orientation="left">Upload CSV File</Divider>

        <Upload
          accept=".csv"
          beforeUpload={(file) => {
            const isCsv = file.type === "text/csv" || file.name.endsWith(".csv");
            if (!isCsv) {
              message.error("You can only upload CSV files!");
              return Upload.LIST_IGNORE;
            }
            setBulkUploadFile(file);
            return false;
          }}
          onRemove={() => {
            setBulkUploadFile(null);
          }}
          fileList={bulkUploadFile ? [bulkUploadFile] : []}
          maxCount={1}
        >
          <Button icon={<UploadOutlined />}>Select CSV File</Button>
        </Upload>

        <div style={{ marginTop: 16 }}>
          <a
            href="/sample_payments_upload.csv"
            download="sample_payments_upload.csv"
            style={{ color: ZAMBIAN_COLORS.green }}
          >
            <FileExcelOutlined /> Download Sample Template
          </a>
        </div>

        {bulkUploadLoading && (
          <div style={{ marginTop: 16 }}>
            <Progress percent={bulkUploadProgress} status="active" />
            <p style={{ textAlign: "center", marginTop: 8 }}>
              Processing payments... Please don't close this window.
            </p>
          </div>
        )}
      </Modal>
    </div>
  );

  async function handleBulkPaymentUpload() {
    if (!bulkUploadFile) {
      message.error("Please select a CSV file first");
      return;
    }

    setBulkUploadLoading(true);
    setBulkUploadProgress(10);

    try {
      // Parse CSV file
      const parseResult = await new Promise((resolve, reject) => {
        Papa.parse(bulkUploadFile, {
          header: true,
          complete: resolve,
          error: reject,
          skipEmptyLines: true,
        });
      });

      const csvData = parseResult.data;
      if (csvData.length === 0) {
        throw new Error("No data found in CSV file");
      }

      setBulkUploadProgress(20);

      const successes = [];
      const errors = [];
      const total = csvData.length;

      // Process each payment
      for (let i = 0; i < csvData.length; i++) {
        const row = csvData[i];
        try {
          // Validate required fields
          if (!row.loan_id || !row.payment_amount || !row.payment_date) {
            errors.push({
              row: i + 2,
              data: row,
              error: "Missing required fields (loan_id, payment_amount, or payment_date)",
            });
            continue;
          }

          // Fetch loan details
          const loanResponse = await axios.get(
            `https://zedlenders.pickmesms.com/items/loans/${row.loan_id}?fields=*,borrower.*`,
            { headers: { Authorization: `Bearer ${token}` } }
          );

          const loan = loanResponse.data.data;

          if (!loan) {
            errors.push({
              row: i + 2,
              data: row,
              error: `Loan with ID ${row.loan_id} not found`,
            });
            continue;
          }

          // Create transaction payload
          const transactionPayload = {
            company: company.id,
            transaction_type: row.transaction_type || "Loan Repayment",
            amount: parseFloat(row.payment_amount),
            payment_method: row.payment_method || "cash",
            transaction_date: row.payment_date,
            loan: loan.id,
            from_account: null, // Borrower payment coming in
            to_account: null, // Will be set based on your accounting logic
            reference_number: row.reference_number || `PAY-${Date.now()}`,
            status: "published",
          };

          // Create the transaction
          await axios.post(
            "https://zedlenders.pickmesms.com/items/transactions",
            transactionPayload,
            { headers: { Authorization: `Bearer ${token}` } }
          );

          // Update loan's paid_amount
          const currentPaidAmount = loan.paid_amount || 0;
          const newPaidAmount = currentPaidAmount + parseFloat(row.payment_amount);

          await axios.patch(
            `https://zedlenders.pickmesms.com/items/loans/${loan.id}`,
            {
              paid_amount: newPaidAmount,
            },
            { headers: { Authorization: `Bearer ${token}` } }
          );

          successes.push({
            row: i + 2,
            loan_id: row.loan_id,
            amount: row.payment_amount,
          });
        } catch (err) {
          errors.push({
            row: i + 2,
            data: row,
            error: err.response?.data?.errors?.[0]?.message || err.message,
          });
        }

        // Update progress
        const progress = 20 + ((i + 1) / total) * 70;
        setBulkUploadProgress(Math.round(progress));
      }

      setBulkUploadProgress(100);

      // Show results
      if (successes.length > 0) {
        message.success(
          `Successfully created ${successes.length} payment(s)!`,
          5
        );
      }

      if (errors.length > 0) {
        console.error("Bulk upload errors:", errors);
        message.warning(
          `${errors.length} payment(s) failed to upload. Check console for details.`,
          5
        );
      }

      // Close modal and refresh page
      setTimeout(() => {
        setShowBulkUploadModal(false);
        setBulkUploadFile(null);
        setBulkUploadProgress(0);
        setBulkUploadLoading(false);
        fetchTransactions();
      }, 2000);
    } catch (error) {
      console.error("Bulk upload error:", error);
      message.error(
        `Failed to process bulk upload: ${error.message}`,
        5
      );
      setBulkUploadLoading(false);
      setBulkUploadProgress(0);
    }
  }
};

export default TransactionsPage;
